// import ChartV5 from '../../pages/paz-ciudadana/ChartV5';
import ChartApi from '../../../pages/paz-ciudadana/paz-ciudadana-v2/ChartApi';

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <ChartApi />
            {/* <ChartV5 /> */}
          </div>
        </div>
      </div>
    </div>
  )
}
